
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Vendor } from '../../../models/vendor.model';
import { AlertService } from '../../../services/alert.service';


@Component({
    selector: 'create-edit-vendor-modal',
    template: require('./create-edit-vendor-modal.component.html'),
    styles: [require('./create-edit-vendor-modal.component.css')]
})
export class CreateEditVendorModalComponent {
    vendors: Vendor[];
    currentVendor: Vendor;
    isCreatNew: boolean;
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditVendorModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.vendors = data.vendors;
        this.isCreatNew = (data.currentVendor.vendorId == undefined);
        this.currentVendor = data.currentVendor;
       
    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateVendor(this.currentVendor).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Vendor successfully");
                }
            });
        } else {
            this.apiService.createVendor(this.currentVendor).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Vendor successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/vendors/create-edit-vendor-modal/create-edit-vendor-modal.component.ts